import { render } from "./uiuxPortfolio.vue?vue&type=template&id=2cc05e5f&scoped=true"
import script from "./uiuxPortfolio.vue?vue&type=script&lang=js"
export * from "./uiuxPortfolio.vue?vue&type=script&lang=js"

import "./uiuxPortfolio.vue?vue&type=style&index=0&id=2cc05e5f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cc05e5f"]])

export default __exports__